import { useEffect } from "react";
import { useIsSmallScreen } from "./useIsSmallScreen";

// Several consumers can be mounted at once (thread composer + main composer),
// so the meta tag is only touched by the first and restored by the last.
let lockCount = 0;
let contentBeforeLock: string | null = null;

// iOS auto-zooms the page when focus lands on a field smaller than 16px, and
// stays zoomed until the user pinches back. Pinning maximum-scale suppresses
// that auto-zoom, so fields can keep their design font size. iOS 10+ still
// honours user pinch gestures, so this does not trap the viewport.
export const useLockViewportScale = (enabled = true) => {
  const isSmallScreen = useIsSmallScreen();

  useEffect(() => {
    if (!enabled || !isSmallScreen) return;

    const meta = document.querySelector<HTMLMetaElement>(
      'meta[name="viewport"]'
    );

    if (!meta) return;

    if (lockCount === 0) {
      contentBeforeLock = meta.content;
      meta.content = `${meta.content}, maximum-scale=1`;
    }

    lockCount += 1;

    return () => {
      lockCount -= 1;

      if (lockCount === 0 && contentBeforeLock !== null) {
        meta.content = contentBeforeLock;
        contentBeforeLock = null;
      }
    };
  }, [enabled, isSmallScreen]);
};
